<template>
  <div class="row">
    <router-link to="/"><img class="logo" src="/img/logo_mag.svg" alt=""></router-link>
  </div>
  <div class="row">
    <ul class="aside-ul">
      <router-link to="/" @click="closeMenuOnMobile">
        <li class="aside-li">
          <span class="icon-HouseLine"></span>
          Дашборд
        </li>
      </router-link>
      <!-- <router-link to="/disp" v-if="currentUser.groups.includes('Диспетчерская')">
        <li class="aside-li">
          <span class="icon-list"></span>
          Дашборд Диспетчерская
        </li>
      </router-link> -->
      <div v-if="currentUser.groups.includes('Сотрудники')">
        <router-link to="/analytics" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Аналитика
          </li>
        </router-link>
        <router-link to="/reports" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Отчёты
          </li>
        </router-link>
      </div>

      <div v-if="currentUser.groups.includes('Полигон') && currentUser.company_inn">
        <hr>
        <router-link to="/polygon/profile" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Профиль
          </li>
        </router-link>
        <router-link to="/polygon/contracts" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Договоры
          </li>
        </router-link>
        <router-link to="/polygon/all-contracts" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Список заявок
          </li>
        </router-link>
        <router-link :to="{
                          name: 'partner_waste_reports',
                          params: { id: currentUser.company_inn[0] }
                        }" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Отчёт по видам отходов
          </li>
        </router-link>
        <router-link to="/polygon/history" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            История рейсов
          </li>
        </router-link>
        <router-link to="/polygon/cars" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Автомобили
          </li>
        </router-link>
      </div>
      <div v-if="currentUser.groups.includes('Экология')">
        <hr>
        <router-link to="/ecology/partners" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Контрагенты
          </li>
        </router-link>
        <router-link to="/ecology/contracts" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Договоры
          </li>
        </router-link>
        <router-link to="/ecology/waste_reports" @click="closeMenuOnMobile">
          <li class="aside-li">
            <span class="icon-File"></span>
            Отчёт по видам отходов
          </li>
        </router-link>
      </div>
      <!-- <li class="aside-li" v-on:click="dropDown=!dropDown">
        <span class="icon-Graph"></span>
        Алгоритмы
        <span class="icon-CaretDown"></span>

      </li>

        <ul class="aside-open-ul">
          <router-link to="/algorithms">
            <li class="aside-open-li" :class="{ 'close' : !dropDown }">
              <span class="icon-CaretRight"></span>
              Обработчики
            </li>
          </router-link>
          <router-link to="/sources">
            <li class="aside-open-li" :class="{ 'close' : !dropDown }">
              <span class="icon-CaretRight"></span>
              Источники
            </li>
          </router-link>
          <router-link to="/addresses">
            <li class="aside-open-li" :class="{ 'close' : !dropDown }">
              <span class="icon-CaretRight"></span>
              Адресаты
            </li>
          </router-link>
        </ul>
      <router-link to="/users">
        <li class="aside-li">
          <span class="icon-Users"></span>
          Пользователи
        </li>
      </router-link>
      <router-link to="/settings">
        <li class="aside-li">
          <span class="icon-SlidersHorizontal"></span>
          Настройки
        </li>
      </router-link> -->
    </ul>
  </div>
</template>

<script>
export default {
  // data() {
  //   return {
  //     dropDown: false,
  //   },
  // },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    closeMenuOnMobile() {
      // Закрываем меню только на мобильных устройствах
      if (window.innerWidth <= 768 && this.$store.state.showMenu) {
        this.$store.dispatch('toggleShowMenu');
      }
    }
  }
}
</script>